// src/data/openRolesAdapter.js
//
// REPORTS-OPEN-ROLES: Client-side data adapter for the Open Roles report.
//
// Fetches GET /api/greenhouse/open-roles-report.
//
// Both functions are plain async functions (not a hook) so they can be
// composed into the report component's useEffect pattern matching the
// existing reportsClient.js convention.

/**
 * Fetch the fractionalized open-roles report from the server.
 *
 * @returns {Promise<{
 *   markets: object[],
 *   remote: number,
 *   unmatched: number,
 *   kpis: { totalReqs: number, officeBased: number, remote: number, inPressure: number, departments: number },
 *   freshness: { pulledAt: string|null, stale: boolean },
 * }>}
 */
export async function getOpenRolesReport() {
  const res = await fetch("/api/greenhouse/open-roles-report", {
    credentials: "include",
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `HTTP ${res.status}`);
  }
  return res.json();
}

export async function getOpenRolesMonthlyHistory() {
  const res = await fetch("/api/greenhouse/open-roles-monthly-history", {
    credentials: "include",
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `HTTP ${res.status}`);
  }
  return res.json();
}
